module.exports = __webpack_public_path__ + "img/yuba.4706f1ec.png";